import type { ExportColumnSelectionFeature } from "@/types/exportFeatures";

export function buildExportParams(
  baseParams: URLSearchParams | undefined,
  selectedColumns: string[],
  columnSelection: ExportColumnSelectionFeature | undefined,
): URLSearchParams {
  const params = baseParams
    ? new URLSearchParams(baseParams)
    : new URLSearchParams();

  if (columnSelection && selectedColumns.length > 0) {
    const paramName = columnSelection.paramName ?? "export_columns";
    params.append(paramName, selectedColumns.join(","));
  }

  return params;
}
